import React, { useState } from 'react';
import axios from 'axios';
import './stylesheets/LoginForm.css'

function LoginForm({ setIsLoggedIn }) {
  const [auth, setAuth] = useState({
    username: '',
    password: '',
    securitytoken: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Handle input changes
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setAuth((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  // Handle login submission
  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    // Validate if username is provided but no password
    if (auth.username && !auth.password) {
      setErrorMessage('Password is required when username is provided.');
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/login/`,{
        username: auth.username.toLowerCase(),
        password: auth.password,
        securitytoken: auth.securitytoken,
      }, {
        headers: {
          'Content-Type': 'application/json',
        }
        
      });

      // Handle successful login
      if (response.status === 200) {
        setIsLoggedIn(true);
        localStorage.setItem('isLoggedIn', 'true');
      } else {
        setErrorMessage('Invalid credentials. Please try again.');
      }

    } catch (error) {
      // Check if response contains data and handle errors accordingly
      if (error.response) {
        const errorData = error.response.data;
        if (auth.securitytoken && auth.securitytoken.trim() !== '') {
          if (errorData.error === 'Invalid security token') {
            setErrorMessage('Invalid security token.');
          }
        } else {
          if (errorData.error === 'Invalid username or password') {
            setErrorMessage('Invalid username or password.');
          } else {
            setErrorMessage('Login failed. Please check your credentials.');
          }
        }
      } else {
        // General error fallback
        setErrorMessage('An unexpected error occurred. Please try again later.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const isSecurityTokenRequired = !(auth.username || auth.password);
  const isSecurityTokenNotEmpty = auth.securitytoken.trim() !== '';

  return (
    <div className='login-form-wrapper'>
      <div className="login-form-container">
        {/* <div className='LoginText'>LOGIN</div> */}
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        <form onSubmit={handleLogin}>
          {/* Username Field */}
          {!isSecurityTokenNotEmpty && (
            <div className="input-container">
              <input
                type="text"
                id="username"
                placeholder="Username"
                value={auth.username}
                onChange={handleInputChange}
                required={!auth.securitytoken && !auth.password}
                disabled={isLoading}
              />
            </div>
          )}

          {/* Password Field */}
          {!isSecurityTokenNotEmpty && (
            <div className="input-container">
              <input
                type="password"
                id="password"
                placeholder="Password"
                value={auth.password}
                onChange={handleInputChange}
                required={!auth.securitytoken && !auth.username}
                disabled={isLoading}
              />
            </div>
          )}

          {/* Show "OR" only when all fields are empty */}
          {!(auth.username || auth.password || auth.securitytoken) && <span className='or-container' >OR</span>}

          {/* Security Token Field */}
          {isSecurityTokenRequired && (
            <div className="input-container">
              <input
                type="password"
                id="securitytoken"
                placeholder="Security Token"
                value={auth.securitytoken}
                onChange={handleInputChange}
                required={isSecurityTokenRequired}
                disabled={isLoading}
              />
            </div>
          )}

          <button className="generic-button" type="submit" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
